/**
 * Defines the threshold percentages that determine whether a FreeWall counts as viewable
 */
export enum VisibilityThresholds {
    default = 100
}
